import merge from 'lodash/merge';
import VueType from 'vue';

export default {
    install: function(Vue: typeof VueType, options: object)
    {
        let methods = {
            close(): void
            {
                // Vue.toasted.clear();
            },
            success(message: string): void
            {
                methods.show(message, 'success', {
                    icon: 'fa-check'
                });
            },
            info(message: string): void
            {
                methods.show(message, 'info', {
                    icon: 'fa-info'
                });
            },
            warning(message: string): void
            {
                methods.error(message);
            },
            danger(message: string): void
            {
                methods.error(message);
            },
            error(message: string): void
            {
                methods.show(message, 'error', {
                    icon: 'fa-exclamation'
                });
            },
            show(message: string, variant: string, options: object): void
            {
                // @ts-ignore
                Vue.toasted[variant](message, merge({
                    action: {
                        text: Vue.i18n.$t('[[[Lukk]]]'),
                        onClick: (e: any, toastObject: any) =>
                        {
                            toastObject.goAway(0);
                        }
                    }
                }, options));
            }
        };

        Vue.alert = Vue.prototype.$alert = methods;
    }
};

declare module 'vue/types/vue'
{
    interface Vue
    {
        $alert: {
            close(): void;
            success(message: string): void;
            info(message: string): void;
            warning(message: string): void;
            danger(message: string): void;
            error(message: string): void;
            show(message: string, variant: string, options: object): void;
        };
    }
    interface VueConstructor
    {
        alert: {
            close(): void;
            success(message: string): void;
            info(message: string): void;
            warning(message: string): void;
            danger(message: string): void;
            error(message: string): void;
            show(message: string, variant: string, options: object): void;
        };
    }
}
